import React from 'react';

const CategoryHelpList = () => (
    <div style={{ textAlign: 'center' }}>
        <img
            src="/categories_cheat_sheet.png"
            alt="Categories Cheat Sheet"
            style={{ maxWidth: '100%', height: 'auto', borderRadius: 8 }}
        />
    </div>
);

export default CategoryHelpList;